import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';

import {ConfigurationInterpreter} from '@viamedici-spc/configurator-ts';
import store from '../../store';
import {getProductData} from '../../util/getProductData';
import {
	selectProductData,
	selectProductDatas,
	selectSectionConfig,
	selectSpcConfiguration, selectSpcConfigurations,
	selectSpcSession,
	selectSpcSessions
} from '../../selectors';
import {stringToAttributeId} from './util/spcUtils';
import {filterAndJoin} from '../../util/filterAndJoin';
import {pimText, pimTextDebug} from '../../util/values';
import {valueToIconMap} from '../../valueMaps/valueToIconMap';

@customElement('spc-values-icons')
export class SpcValuesIcons extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				flex-direction: column;
				width: 100%;
				padding-top: 2cqw;
			}
			.title {
				font: var(--font-specsheet-print-small-text);
				font-size: 1cqw;
				color: #939393;
			}
			.icons {
				display: flex;
				flex-direction: row;
				width: 100%;
				gap: 0.2cqw;
			}
			.icon {
				display: block;
				height: 4cqw;
			}
		`];

	@property({type: String})
	attributeKey = {};

	@property({type: String})
	context = '';

	@property({type: String})
	suffix = '';

	@property({type: String})
	instanceId = 'default';

	constructor() {
		super();
		this.translations = {};
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.debug = state.status.debug;
		this.lang = state.status.lang;
		this.region = state.status.region;

		this.attributeId = stringToAttributeId(this.attributeKey);
		this.context = 'FV.S';

		this.sectionConfig = selectSectionConfig(state);
		this.section = this.sectionConfig[0];

		this.session = selectSpcSessions(state)[this.instanceId];
		if (!this.session) return;

		this.deploymentName = this.session.getSessionContext().configurationModelSource.deploymentName;
		const productDatas = selectProductDatas(state);

		if (Object.hasOwn(productDatas, this.deploymentName)) {
			this.translations = productDatas[this.deploymentName].translations;
		}

		const spcConfigurations = selectSpcConfigurations(state);
		if (spcConfigurations && Object.hasOwn(spcConfigurations, this.instanceId)) {
			this.spcConfiguration = spcConfigurations[this.instanceId];
		}

		if (this.spcConfiguration) {
			this.attribute = ConfigurationInterpreter.getChoiceAttribute(this.spcConfiguration, this.attributeId);
			if (this.attribute) {
				this.specSheetValuesDisplay = this.section.attributeOptions?.[this.attribute.key]?.specSheetValuesDisplay ?? 'list';
				this.values = Array.from(this.attribute.values.values()).filter(v => v.possibleDecisionStates.includes('Included'));
			}
		}
		if (this.display) {
			this.specSheetValuesDisplay = this.display;
		}
	}

	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}

	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.spcConfiguration, this.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.spcConfiguration, this.translations, value, prefix, suffix);
	}

	render() {
		if (!this.values) return null;
		const valueIds = this.values
			//.sort((a, b) => this.getProductDataForValue(a.id)?.displaySequenceUi - this.getProductDataForValue(b.id)?.displaySequenceUi)
			.map(value => value.id);
		if (valueIds.length === 0) return null;

		// if at least one of the valueIds is defined in valueIcons
		if (!valueIds.some(valueId => Object.hasOwn(valueToIconMap, valueId)) ) return null;

		return html`
			<trans-label class="title" key="${this.attributeKey}" context="F"></trans-label>
			<div class="icons">
				${repeat(valueIds, valueId => valueId, (valueId) => html`
					<img class="icon" src="${valueToIconMap[valueId]}"/>
				`)}
			</div>
        `;
	}
}
